<div class="img-container">
  <img [src]="imgFile?.thumbnail" alt="img" />
  <div class="clear-btn global-transition" (click)="onRemove()">
    <nb-icon class="basket" icon="basket-filled" pack="icomoon"></nb-icon>
  </div>
</div>
